class ChangePaymentMethod {
    constructor() {
        this.initChangePaymentMethod();
        this.changePaymentRadioButtons();
    }
    initChangePaymentMethod(){
        const changePaymentBtns = document.querySelectorAll('.payment-method-container .change-payment-method');
        changePaymentBtns.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function (e) {
                let organizationID = e.currentTarget.getAttribute('data-value');
                if(organizationID){
                    let changePaymentModal = document.getElementById('change_payment_method_modal');
                    let changePaymentMethodBtn = changePaymentModal.querySelector('#changePaymentMethodBtn');
                    if(changePaymentMethodBtn){
                        changePaymentMethodBtn.href = '/payments/change-method/?organizationID='+organizationID+'&method='+changePaymentModal.querySelector('input[name=method]:checked').value;
                        new bootstrap.Modal(changePaymentModal).show();
                    }
                }
            });
        });
    }
    changePaymentRadioButtons(){
        let changePaymentModal = document.getElementById('change_payment_method_modal');
        const changePaymentRadios = changePaymentModal.querySelectorAll('input[name=method]');
        changePaymentRadios.forEach(c => {
            // Checkbox on click event
            c.addEventListener('change', function (e) {
                let paymentMethod = this.value;
                let changePaymentMethodBtn = changePaymentModal.querySelector('#changePaymentMethodBtn');
                if(changePaymentMethodBtn){
                    const url = new URL(changePaymentMethodBtn.href);
                    const search_params = url.searchParams;
                    search_params.set('method', paymentMethod);
                    url.search = search_params.toString();
                    changePaymentMethodBtn.href = url.toString();
                }
            });
        });
    }
}
window.ChangePaymentMethod = ChangePaymentMethod;